export class StatusUtils {
  static getErrorMessage(response: Response): string {
    let errorMessage: string;

    switch (response.status) {
      case 400:
        errorMessage = 'Bad Request 400';
        break;
      case 403:
        errorMessage = 'Forbidden 403';
        break;
      case 404:
        errorMessage = 'Not Found 404';
        break;
      case 405:
        errorMessage = 'Method Not Allowed 405';
        break;
      default:
        errorMessage = `Error ${response.status})`;
    }

    return errorMessage;
  }
}
